export const getThumbnailedBackground = (mobile, landscape) => ({ backgroundImage, backgroundImageMobile, backgroundImageMobileHorizontal, thumbnail }) => {
    return (
        `${landscape && backgroundImageMobileHorizontal ?
            `url(${backgroundImageMobileHorizontal})` : mobile && backgroundImageMobile ?
            `url(${backgroundImageMobile})` : backgroundImage ? `url(${backgroundImage})` : 'none'} ${thumbnail ? `, url(${thumbnail})` : ''}`
    )
};
